import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {QuotesComponent} from './quotes.component';
import {OpenQuotesComponent} from './open-quotes/open-quotes.component';
import {QuotesItemDetailComponent} from './quotes-item-detail/quotes-item-detail.component';
import {ExpiredQuotesComponent} from './expired-quotes/expired-quotes.component';
import {PriceListComponent} from './price-list/price-list.component';
import {PriceListDetailComponent} from './price-list/price-list-detail/price-list-detail.component';
import {PriceListSummaryComponent} from './price-list/price-list-detail/price-list-summary/price-list-summary.component';
import {PriceListCheckoutComponent} from './price-list/price-list-detail/price-list-summary/price-list-checkout/price-list-checkout.component';
import {SelectLocationComponent} from '../my-carts/check-out/shipping-address/select-location/select-location.component';
import {TenantComponent} from '../my-carts/check-out/tenant/tenant.component';
import {EndUserComponent} from '../my-carts/check-out/end-user/end-user.component';
import {SelectEndUserComponent} from '../my-carts/check-out/end-user/select-end-user/select-end-user.component';
import {PaymentComponent} from '../my-carts/check-out/payment/payment.component';
import {DonationComponent} from '../my-carts/check-out/donation/donation.component';
import {ShippingAddressComponent} from '../my-carts/check-out/shipping-address/shipping-address.component';
import {SummaryOrderComponent} from '../my-carts/check-out/summary-order/summary-order.component';
import {OrderConfirmationComponent} from '../my-carts/check-out/order-confirmation/order-confirmation.component';
import {PaymentSetupComponent} from '../my-account/payment-setup/payment-setup.component';
import {FreightShipMethodComponent} from '../my-carts/check-out/freight-ship-method/freight-ship-method.component';
import {QuoteGuard} from './price-list/quote.guard';
import {CanActivatePriceList} from './price-list.guard';

const routes: Routes = [
  {
    path: 'quotes',
    component: QuotesComponent,
    data: {
      breadcrumb: 'Quotes',
    },
    children: [
      // {
      //     path: '',
      //     // Maken the Open Quotes as the default routing
      //     redirectTo: 'openQuotes',
      //     pathMatch: 'full'
      // },
      {
        path: 'openQuotes',
        component: OpenQuotesComponent,
        data: {
          breadcrumb: 'Open Quotes',
        },
        children: [
          {
            path: 'quotesItemsDetials/:sku/:version',
            component: QuotesItemDetailComponent,
            data: {
              breadcrumb: 'sku',
            },
          }
        ]
      },
      {
        path: 'expiredQuotes',
        component: ExpiredQuotesComponent,
        data: {
          breadcrumb: 'Recently Expired Quotes',
        },
        children: [
          {
            path: 'quotesItemsDetials/:sku/:version',
            component: QuotesItemDetailComponent,
            data: {
              breadcrumb: 'sku',
            },
          }
        ]
      },
      {
        path: 'pricelist',
        component: PriceListComponent,
        data: {
          breadcrumb: 'Price List',
        },
        canActivate: [CanActivatePriceList],
        children: [
          {
            path: 'pricelistDetails/:sku/:version',
            component: PriceListDetailComponent,
            data: {
              breadcrumb: 'sku',
            },
            children: [
              {
                path: 'viewSummary/:expiry',
                component: PriceListSummaryComponent,
                data: {
                  breadcrumb: 'Price List Summary',
                },
                canActivate: [QuoteGuard],
                children: [
                  {
                    path: 'checkout/:id/:cartName',
                    component: PriceListCheckoutComponent,
                    data: {
                      breadcrumb: 'price list checkout'
                    },
                    children: [
                      {
                        path: 'ship-address',
                        component: ShippingAddressComponent,
                        data: {
                          breadcrumb: 'Ship Address',
                        },
                        children: [
                          {
                            path: 'select-location',
                            component: SelectLocationComponent,
                            data: {
                              breadcrumb: 'Select Location',
                            },
                          },
                        ]
                      },
                      {
                        path: 'freight-ship',
                        component: FreightShipMethodComponent,
                        data: {
                          breadcrumb: 'Freight & Shipping Method',
                        },
                      },
                      {
                        path: 'donation',
                        component: DonationComponent,
                        data: {
                          breadcrumb: 'Donation',
                        },
                      },
                      {
                        path: 'payment-method',
                        component: PaymentComponent,
                        data: {
                          breadcrumb: 'Payment',
                        },
                      },
                      // {
                      //     path: 'digitalwallet',
                      //     component: PaymentSetupComponent,
                      //     data: {
                      //         breadcrumb: 'Digital Wallet',
                      //     },
                      // },
                      {
                        path: 'summary-order',
                        component: SummaryOrderComponent,
                        data: {
                          breadcrumb: 'Summary & Order',
                        },
                      },
                      {
                        path: 'end-user',
                        component: EndUserComponent,
                        data: {
                          breadcrumb: 'End User Information',
                        }
                      },
                      {
                        path: 'selectenduser',
                        component: SelectEndUserComponent,
                        data: {
                          breadcrumb: 'Select End User',
                        }
                      },
                      {
                        path: 'tenant',
                        component: TenantComponent,
                        data: {
                          breadcrumb: 'Tenant Information',
                        }
                      },
                      {
                        path: 'order-confirmation',
                        component: OrderConfirmationComponent
                      }
                    ]
                  }
                ]
              }

            ]

          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuotesPageRoutingModule {
}
